var _circle, _path, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBadGuy(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 15,
    fill: "#9146A4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.0005 29.999C23.2848 29.999 30.0005 23.2833 30.0005 14.999C30.0005 12.4173 29.3482 9.98786 28.1995 7.86658C25.5624 5.56217 22.1112 4.16602 18.334 4.16602C10.0497 4.16602 3.33398 10.8817 3.33398 19.166C3.33398 21.7478 3.98624 24.1772 5.13494 26.2985C7.7721 28.6029 11.2233 29.999 15.0005 29.999Z",
    fill: "#9D59AE"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_910_20686)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.4345 11.53C13.472 12.0713 14.0906 12.3678 14.5377 12.0602C14.931 11.7895 15.4678 12.0715 15.4678 12.5493V14.5152H16.9406C16.6791 13.4472 17.5259 12.4066 18.6524 12.4844C19.6435 12.5531 20.3785 13.5075 20.131 14.5152H21.6186C22.8635 12.6331 21.6098 9.91014 19.1841 9.78558C19.4583 8.33711 18.3415 7.00195 16.8778 7.00195C16.3491 7.00195 15.8607 7.1777 15.4678 7.47377V10.4079C15.4678 10.8854 14.9314 11.1679 14.5376 10.897C14.0592 10.5679 13.393 10.9315 13.4345 11.53V11.53Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.3914 14.5157C10.869 14.5157 11.1514 15.0523 10.8804 15.446C10.5528 15.922 10.9125 16.5903 11.5135 16.5488C12.0561 16.5112 12.3511 15.8922 12.0439 15.4459C11.7731 15.0524 12.0553 14.5157 12.533 14.5157H14.5306V13.0737C13.5205 13.3218 12.568 12.5841 12.4995 11.5952C12.4217 10.4735 13.4579 9.62106 14.5306 9.88371V7.47428C12.8489 6.2069 10.4398 7.65403 10.8088 9.75506C8.36858 9.88471 7.13367 12.6136 8.38926 14.5157H10.3914Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.6029 15.4529H19.607C19.1291 15.4529 18.847 14.9162 19.1179 14.5227C19.4253 14.0763 19.1295 13.4574 18.5875 13.4198C17.9865 13.3781 17.6266 14.0464 17.9543 14.5226C18.2252 14.9163 17.943 15.4529 17.4653 15.4529H15.4678V16.8941C16.5374 16.6322 17.5769 17.4812 17.4989 18.6056C17.4303 19.5948 16.4775 20.332 15.4678 20.0841V22.5257C17.1495 23.793 19.5586 22.3459 19.1896 20.2449C21.5711 20.1183 22.8949 17.4465 21.6029 15.4529V15.4529Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5637 18.5407C16.6051 17.9425 15.9389 17.5786 15.4605 17.9079C15.067 18.1785 14.5303 17.8967 14.5303 17.4188V15.4529H13.0567C13.3118 16.491 12.5211 17.4878 11.4599 17.4878C10.3886 17.4878 9.61504 16.4784 9.86632 15.4529H8.38913C7.13423 17.3548 8.36673 20.0882 10.8141 20.2138C10.5398 21.6623 11.6567 22.9975 13.1203 22.9975C13.649 22.9975 14.1375 22.8217 14.5303 22.5257V19.5602C14.5303 19.0828 15.0668 18.8002 15.4604 19.0711C15.9066 19.3782 16.526 19.0832 16.5637 18.5407Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_910_20686"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(7 7)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBadGuy);
export default __webpack_public_path__ + "static/media/bad-guy.ccf384fd3ef5bcc73d4056e3aa6dff77.svg";
export { ForwardRef as ReactComponent };